import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchConnectedDevices } from './deviceThunks';
import { fetchIntegrations, fetchSystemTypeMap } from './systemThunks';

// Bootstrap fetch that consolidates integration data loading.
export const fetchIntegrationThunk = createAsyncThunk(
  'integration/fetchIntegrationThunk',
  async (_, { dispatch }) => {
    await Promise.all([
      dispatch(fetchSystemTypeMap()),
      dispatch(fetchConnectedDevices()),
    ]);
    return true;
  },
);
